export default {
    namespaced: true,
    state: {
        query: null,
        pages: [], // array of objects/arrays containing the data from the queries
        loading: null,
        error: null,
        hasNextPage: true,
        queryInfo: null, // The last queryInfo received from pushPage, NB any new queryInfo will overwrite this value!
    },
    getters: {
        getPages: state => ({ start = 1, end }) => {
            const data = state.pages
                .slice(start - 1, end)
                .reduce(
                    (acc, val) => [
                        ...acc,
                        ...(val instanceof Array ? val : [val]),
                    ],
                    []
                );
            return {
                data,
                loading: state.loading,
                error: state.error,
                queryInfo: state.queryInfo,
            };
        },
    },
    mutations: {
        setQuery(state, query) {
            state.query = query;
        },
        setPages(state, data) {
            state.pages = data ? data : [];
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setError(state, error) {
            state.error = error;
        },
        setHasNextPage(state, value) {
            state.hasNextPage = value;
        },
        setQueryInfo(state, queryInfo) {
            state.queryInfo = queryInfo;
        },
        resetPool(state, { queryName, initPageSize }) {
            state.loading = null;
            state.error = null;
            state.query = queryName;
            state.pages = new Array(initPageSize);
            state.hasNextPage = true;
            state.queryInfo = null;
        },
    },
    actions: {
        initPool({ commit, state }, { queryName, initPageSize = 10 }) {
            commit('resetPool', { queryName, initPageSize });
        },
        pushPage({ commit, state }, { data, index, queryInfo }) {
            if (!data) {
                commit('setHasNextPage', false);
                return;
            }
            let nextMissing = index - 1 || state.pages.findIndex(it => !it);
            if (nextMissing === -1) {
                commit('setPages', [...state.pages, data]);
            } else {
                let temp = state.pages;
                temp[nextMissing] = data;
                commit('setPages', temp);
            }
            if (queryInfo) commit('setQueryInfo', queryInfo);
        },
    },
};
